import GjwSelect from './src/GjwSelect'

GjwSelect.install = function(Vue) {
  Vue.component(GjwSelect.name, GjwSelect)
}

export default GjwSelect
